<div class="dialog-wrapper form-dialog add-document-modal">
  <ng-template #customDialogHeaderTemplate>
    <div class="title-container">
      <h1>{{'ADD_DOCUMENT' | translate}}</h1>
    </div>
  </ng-template>

  <ng-template #customDialogFooterTemplate>
    <div class="button-wrapper">
      <button
        id="cancelDocument"
        class="btn ghost-btn ghost-default"
        (click)="close()"
      >
        {{'BUTTON_CLOSE' | translate}}
      </button>
    </div>
  </ng-template>

  <pulse-dialog
    *ngIf="hideDialog  && showDocsWidget"
    [styles]="style"
    [isModelOpen]="true"
    [headerTemplate]="customDialogHeaderTemplate"
    [footerTemplate]="customDialogFooterTemplate"
    (closeDialog)="close()"
  >
    <div class="binf-widgets">
      <div
        id="newDocCtnr"
        class="row-xs-full"
      ></div>
    </div>
    <div
      class="error-msg"
      *ngIf="error"
    >
      {{errorMsg}}
    </div>
  </pulse-dialog>
</div>
<app-cbre-loader *ngIf="isLoaderVisible"></app-cbre-loader>